import React from "react";
import { getCurrentCountry, getCurrentLanguage, isBrowser } from "../utils/common";

export default () => {
  // fetch translations
  const storageKey = `translate_web_wucom_${getCurrentCountry()}_${getCurrentLanguage()}`;
  const translations = sessionStorage.getItem(storageKey) ? JSON.parse(sessionStorage.getItem(storageKey))['signup-overlay'] : null;
  sessionStorage.removeItem('loggedInByOverlay');
  !!isBrowser() && window.scrollTo(0, 0);
  return (
    translations ? <>
     <div class="wu-message signin-msg-one">
        <div class="wu-message__page-level">
          <div class="wu-message__page-level__title wu-message__page-level__title--success overlay-signin-msg-one">
            <p class="font-body-xs m-auto white-space-nowrap">{translations["notification-title"]}</p>
          </div>
        </div>
      </div>
      <div class="wu-message">
        <div class="wu-message__page-level">
          <div class="wu-message__page-level__title wu-message__page-level__title--white overlay-signin-msg-two">
            <i data-grunticon-embed="" class="wu-icon success wu-icon-heading__sm overlay-signin-icon" data-wu-icon="wu-icon-heading__sm">
              <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <title>0081_done</title>
                <desc>Created with Sketch.</desc>
                <g id="0081_done" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <path d="M16,0 C24.836556,0 32,7.163444 32,16 C32,24.836556 24.836556,32 16,32 C7.163444,32 0,24.836556 0,16 C0,7.163444 7.163444,0 16,0 Z M24.22,9.11 L14,19.335 L7.78,13.11 L6,14.89 L14,22.89 L26,10.89 L24.22,9.11 Z" id="Combined-Shape" fill="#000000"></path>
                </g>
              </svg>
            </i>
            <p class="font-body-xs text-wu-dark white-space-nowrap">{translations["notification-sub-title"]}</p>
          </div>
        </div>
      </div> 
    </> : <></>
  );
}